type localesKeys__Analytics = {
  consentBanner__text: string;
  consentBanner__privacyLink: string;
  consentBanner__accept: string;
  consentBanner__decline: string;
  footerPrivacy__link: string;
  privacyPage__title: string;
  privacyPage__intro: string;
  privacyPage__basisTitle: string;
  privacyPage__basis: string;
  privacyPage__dataTitle: string;
  privacyPage__dataAnalytics: string;
  privacyPage__dataAccount: string;
  privacyPage__dataInterview: string;
  privacyPage__purposesTitle: string;
  privacyPage__purposes: string;
  privacyPage__processorsTitle: string;
  privacyPage__processorsAnalytics: string;
  privacyPage__processorsInterview: string;
  privacyPage__interviewDataTitle: string;
  privacyPage__interviewData: string;
  privacyPage__storageTitle: string;
  privacyPage__storage: string;
  privacyPage__rightsTitle: string;
  privacyPage__rights: string;
  privacyPage__consentTitle: string;
  privacyPage__consent: string;
  privacyPage__backHome: string;
};

const ruLocale__Analytics: localesKeys__Analytics = {
  consentBanner__text: "Сайт использует куки. Как тебе?",
  consentBanner__privacyLink: "Подробнее",
  consentBanner__accept: "Отлично",
  consentBanner__decline: "Не согласен",
  footerPrivacy__link: "О данных",
  privacyPage__title: "Политика обработки персональных данных",
  privacyPage__intro:
    "Оператор — Волобуев Пётр Владимирович, владелец сайта pvolobuev.ru. Политика описывает, какие данные обрабатываются на сайте, с какой целью и как ими управлять. По вопросам обработки данных можно написать на support@pvolobuev.ru.",
  privacyPage__basisTitle: "Субъекты и правовые основания",
  privacyPage__basis:
    "Субъекты персональных данных — пользователи сайта, зарегистрированные в разделе «ИИнтервью». Правовые основания обработки — согласие субъекта на обработку персональных данных, а также исполнение договора (предоставление доступа к сервису).",
  privacyPage__dataTitle: "Какие данные обрабатываются",
  privacyPage__dataAnalytics:
    "Аналитика посещений: обезличенная статистика (просмотренные страницы, источник перехода, устройство, поведение на странице) через Яндекс.Метрику — только после вашего согласия.",
  privacyPage__dataAccount:
    "Регистрация и вход в раздел «ИИнтервью»: адрес электронной почты, имя, логин и пароль. Пароль не хранится в открытом виде — только в виде хеша, полученного с применением надёжных алгоритмов хеширования.",
  privacyPage__dataInterview:
    "Взаимодействие с ИИ-интервью: содержимое ваших сообщений и ответов в диалоге.",
  privacyPage__purposesTitle: "Цели обработки",
  privacyPage__purposes:
    "Предоставление доступа к разделу «ИИнтервью» (регистрация и аутентификация), работа ИИ-диалога, а также улучшение сайта на основе обезличенной статистики.",
  privacyPage__processorsTitle: "Кто обрабатывает данные",
  privacyPage__processorsAnalytics:
    "Аналитика: сервис Яндекс.Метрика (ООО «Яндекс»).",
  privacyPage__processorsInterview:
    "Аутентификация и ИИ-интервью: обработка выполняется сервисами Яндекса (Yandex Cloud / Yandex AI Studio) в дата-центрах на территории Российской Федерации. Данные не передаются третьим лицам за пределами экосистемы Яндекса и не покидают пределы РФ.",
  privacyPage__interviewDataTitle: "Данные в ИИ-диалогах",
  privacyPage__interviewData:
    "Содержимое диалогов с ИИ обрабатывается сервисами Яндекса только для формирования ответов и работы сервиса и не используется для обучения моделей. Диалоги удаляются при удалении учётной записи — не позднее 30 дней после этого.",
  privacyPage__storageTitle: "Хранение данных",
  privacyPage__storage:
    "Данные хранятся на серверах в Российской Федерации. При удалении учётной записи связанные персональные данные удаляются в разумный срок — не позднее 30 дней. Обезличенная статистика хранится в сроки, установленные сервисом аналитики.",
  privacyPage__rightsTitle: "Ваши права",
  privacyPage__rights:
    "Вы вправе запросить доступ к своим данным, их изменение или удаление, а также отозвать ранее данное согласие на обработку. Для этого напишите на support@pvolobuev.ru. Сбор аналитики можно также отклонить в баннере до его начала.",
  privacyPage__consentTitle: "Согласие",
  privacyPage__consent:
    "Аналитика включается только после согласия в баннере (кнопка «Отлично»); отказаться можно кнопкой «Не согласен». При регистрации в разделе «ИИнтервью» вы отдельно подтверждаете согласие на обработку персональных данных. Отозвать согласие можно обращением на support@pvolobuev.ru.",
  privacyPage__backHome: "На главную",
};

const enLocale__Analytics: localesKeys__Analytics = {
  consentBanner__text: "This site uses cookies. How about that?",
  consentBanner__privacyLink: "Learn more",
  consentBanner__accept: "Great",
  consentBanner__decline: "Not OK",
  footerPrivacy__link: "About data",
  privacyPage__title: "Personal data processing policy",
  privacyPage__intro:
    "The operator is Petr Vladimirovich Volobuev, owner of pvolobuev.ru. This policy describes what data is processed on the site, for what purpose and how to manage it. For any data-related questions, write to support@pvolobuev.ru.",
  privacyPage__basisTitle: "Data subjects and legal grounds",
  privacyPage__basis:
    "Data subjects are users of the site registered in the “AInterview” section. The legal grounds for processing are the subject's consent to personal data processing and the performance of a contract (providing access to the service).",
  privacyPage__dataTitle: "What data is processed",
  privacyPage__dataAnalytics:
    "Visit analytics: anonymised statistics (viewed pages, referral source, device, on-page behaviour) via Yandex.Metrica — only after your consent.",
  privacyPage__dataAccount:
    "Registration and sign-in for the “AInterview” section: email address, name, login and password. The password is never stored in plain text — only as a hash produced with strong hashing algorithms.",
  privacyPage__dataInterview:
    "AI interview interaction: the content of your messages and replies in the dialogue.",
  privacyPage__purposesTitle: "Purposes of processing",
  privacyPage__purposes:
    "Providing access to the “AInterview” section (registration and authentication), running the AI dialogue, and improving the site based on anonymised statistics.",
  privacyPage__processorsTitle: "Who processes the data",
  privacyPage__processorsAnalytics:
    "Analytics: the Yandex.Metrica service (Yandex LLC).",
  privacyPage__processorsInterview:
    "Authentication and the AI interview: processing is performed by Yandex services (Yandex Cloud / Yandex AI Studio) in data centres within the Russian Federation. Data is not shared with third parties outside the Yandex ecosystem and does not leave the Russian Federation.",
  privacyPage__interviewDataTitle: "Data in AI dialogues",
  privacyPage__interviewData:
    "The content of AI dialogues is processed by Yandex services only to generate responses and operate the service, and is not used to train models. Dialogues are deleted when your account is deleted — no later than 30 days after that.",
  privacyPage__storageTitle: "Data storage",
  privacyPage__storage:
    "Data is stored on servers within the Russian Federation. When an account is deleted, the associated personal data is removed within a reasonable period — no later than 30 days. Anonymised statistics are kept for the periods set by the analytics service.",
  privacyPage__rightsTitle: "Your rights",
  privacyPage__rights:
    "You may request access to your data, its correction or deletion, and withdraw a previously given consent to processing. To do so, write to support@pvolobuev.ru. You can also decline analytics before it starts via the banner.",
  privacyPage__consentTitle: "Consent",
  privacyPage__consent:
    "Analytics is enabled only after consent in the banner (the “Great” button); you can refuse with “Not OK”. When registering in the “AInterview” section, you separately confirm your consent to personal data processing. You can withdraw consent by writing to support@pvolobuev.ru.",
  privacyPage__backHome: "Back to home",
};

export { ruLocale__Analytics, enLocale__Analytics };
export type { localesKeys__Analytics };
